import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import PublicNav from "@/components/PublicNav";

/**
 * Wraps a public page (legal, contact, etc.) with NextRota header + footer.
 * Stays readable on mobile and inherits the app's typography/colour tokens.
 */
export default function PublicLayout({ title, lastUpdated, children, intro }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F6F9FE]">
      <PublicNav />

      <main className="flex-1 max-w-3xl w-full mx-auto px-6 py-12">
        <div className="eyebrow text-[#4B5773]">NextRota</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-2 text-[#0B1A36]">{title}</h1>
        {lastUpdated && <p className="text-xs uppercase tracking-widest text-[#4B5773] mt-3">{lastUpdated}</p>}
        {intro && <p className="text-base text-[#1F2A44] mt-6 leading-relaxed">{intro}</p>}

        <div className="prose prose-slate max-w-none mt-8 legal-body" data-testid="legal-content">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}
